export const API_V1_1 = process.env.REACT_APP_API_URL_GO_V1_1;
export const API_V1 = process.env.REACT_APP_API_URL_GO_V1;
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const TOKEN_STATIC = process.env.REACT_APP_TOKEN_STATIC;
export const TIMER_RESEND = process.env.REACT_APP_TIMER_RESEND;

export const FETCHING = 'FETCHING';
export const FETCHING_ADMIN = 'FETCHING_ADMIN';
export const FETCHING_CITY = 'FETCHING_CITY';
export const FETCHING_COMPANY_CODE = 'FETCHING_COMPANY_CODE';
export const FETCHING_COUNTRY = 'FETCHING_COUNTRY';
export const FETCHING_DISTRICT = 'FETCHING_DISTRICT';
export const FETCHING_GENDER = 'FETCHING_GENDER';
export const FETCHING_PROVINCE = 'FETCHING_PROVINCE';
export const FETCHING_ROLE = 'FETCHING_ROLE';
export const FETCHING_SALE = 'FETCHING_SALE';
export const FETCHING_TARGET = 'FETCHING_TARGET';
export const FETCHING_VILLAGE = 'FETCHING_VILLAGE';
export const FETCHING_TODO = 'FETCHING_TODO';

export const ERROR_FETCHING = 'ERROR_FETCHING';
export const ERROR_FETCHING_ADMIN = 'ERROR_FETCHING_ADMIN';
export const ERROR_FETCHING_CITY = 'ERROR_FETCHING_CITY';
export const ERROR_FETCHING_COMPANY_CODE = 'ERROR_FETCHING_COMPANY_CODE';
export const ERROR_FETCHING_COUNTRY = 'ERROR_FETCHING_COUNTRY';
export const ERROR_FETCHING_DISTRICT = 'ERROR_FETCHING_DISTRICT';
export const ERROR_FETCHING_GENDER = 'ERROR_FETCHING_GENDER';
export const ERROR_FETCHING_PROVINCE = 'ERROR_FETCHING_PROVINCE';
export const ERROR_FETCHING_ROLE = 'ERROR_FETCHING_ROLE';
export const ERROR_FETCHING_SALE = 'ERROR_FETCHING_SALE';
export const ERROR_FETCHING_TARGET = 'ERROR_FETCHING_TARGET';
export const ERROR_FETCHING_VILLAGE = 'ERROR_FETCHING_VILLAGE';
export const ERROR_FETCHING_TODO = 'ERROR_FETCHING_TODO';

export const GET_ADMINS = 'GET_ADMINS';
export const GET_ADMIN = 'GET_ADMIN';
export const GET_SALES = 'GET_SALES';
export const GET_SALE = 'GET_SALE';
export const GET_TODOS = 'GET_TODOS';
export const GET_TODO = 'GET_TODO';

export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_PROVINCES = 'GET_PROVINCES';
export const GET_CITIES = 'GET_CITIES';
export const GET_DISTRICTS = 'GET_DISTRICTS';
export const GET_VILLAGES = 'GET_VILLAGES';
export const FILTER_COUNTRY = 'FILTER_COUNTRY';
export const FILTER_PROVINCE = 'FILTER_PROVINCE';
export const FILTER_CITY = 'FILTER_CITY';
export const FILTER_DISTRICT = 'FILTER_DISTRICT';
export const FILTER_VILLAGE = 'FILTER_VILLAGE';
export const FILTER_TODOS = 'FILTER_TODOS';
export const FETCHING_TARGET_COUNTRY = 'FETCHING_TARGET_COUNTRY';
export const FETCHING_TARGET_PROVINCE = 'FETCHING_TARGET_PROVINCE';
export const FETCHING_TARGET_CITY = 'FETCHING_TARGET_CITY';
export const FETCHING_TARGET_DISTRICT = 'FETCHING_TARGET_DISTRICT';

export const GET_COMPANY_CODES = 'GET_COMPANY_CODES';
export const GET_GENDERS = 'GET_GENDERS';
export const GET_ROLES = 'GET_ROLES';
export const GET_TARGET_STATISTIC = 'GET_TARGET_STATISTIC';

export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_RECEIVED = 'AUTH_RECEIVED';
export const AUTH_FAILED = 'AUTH_FAILED';
export const AUTH_SIGNOUT = 'AUTH_SIGNOUT';

export const FETCHING_MANAGE_TARGET = 'FETCHING_MANAGE_TARGET';
export const ERROR_FETCHING_MANAGE_TARGET = 'ERROR_FETCHING_MANAGE_TARGET';
export const GET_MANAGE_TARGETS = 'GET_MANAGE_TARGETS';
export const GET_MANAGE_TARGET = 'GET_MANAGE_TARGET';

export const FETCHING_REGION = 'FETCHING_REGION';
export const ERROR_FETCHING_REGION = 'ERROR_FETCHING_REGION';
export const GET_REGIONS = 'GET_REGIONS';
export const GET_REGION = 'GET_REGION';

export const FETCHING_BRANCH = 'FETCHING_BRANCH';
export const ERROR_FETCHING_BRANCH = 'ERROR_FETCHING_BRANCH';
export const GET_BRANCHES = 'GET_BRANCHES';
export const GET_BRANCH = 'GET_BRANCH';

export const FETCHING_AREA = 'FETCHING_AREA';
export const ERROR_FETCHING_AREA = 'ERROR_FETCHING_AREA';
export const GET_AREAS = 'GET_AREAS';
export const GET_AREA = 'GET_AREA';

export const FETCHING_SUBAREA = 'FETCHING_SUBAREA';
export const ERROR_FETCHING_SUBAREA = 'ERROR_FETCHING_SUBAREA';
export const GET_SUBAREAS = 'GET_SUBAREAS';
export const GET_SUBAREA = 'GET_SUBAREA';

export const FETCHING_VALIDATION_MERCHANT = 'FETCHING_VALIDATION_MERCHANT';
export const ERROR_FETCHING_VALIDATION_MERCHANT =
  'ERROR_FETCHING_VALIDATION_MERCHANT';
export const GET_VALIDATION_MERCHANT = 'GET_VALIDATION_MERCHANT';
